module.exports = fox._r("images/slider_open.png", __webpack_public_path__ + "images/slider_open.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/slider_open.png
// module id = 1110
// module chunks = 4